// removed by extract-text-webpack-plugin
module.exports = {"outer":"_39d1","toolbar":"_3IEb"};


//////////////////
// WEBPACK FOOTER
// ./src/features/Messages/MessageCreate/MessageCreate.scss
// module id = Rexz
// module chunks = 0